window.addEventListener("load", function () {
    const navigation = document.querySelector(".cs-nav");
    const metaNav = document.querySelector(".metaNavigation");
    const menuBar = document.querySelector(".menubar");
    const menuToggler = document.querySelector(".mobile-menu-trigger");
    const menuContent = document.querySelector(".menubar-mobile");
    const menuItems = document.querySelectorAll(".menubar-mobile .menu-item");
    const animationTime = 300;

    if (!navigation || menuItems.length === 0 || !menuContent || !menuToggler) return;

    if (metaNav) {
        navigation.style.top = metaNav.offsetHeight + "px";
    }

    menuItems.forEach((item) => {
        item.addEventListener("click", function (e) {
            e.stopPropagation();
            item.classList.toggle("open");
            let submenu = item.querySelector(".sub-menu");
            if (submenu.classList.contains("is-animating")) return;
            submenu.classList.toggle("open");

            if (submenu.classList.contains("open")) {
                const height = getTheoreticalHeight(submenu.parentNode, submenu, "auto");
                animateHeight(submenu, height, animationTime).then(() => {
                    setTimeout(() => {
                        submenu.style.height = "auto";
                    }, 50);
                });
            } else {
                submenu.querySelectorAll(".sub-menu").forEach((item) => {
                    item.classList.remove("open");
                    animateHeight(item, 0, animationTime).then(() => {
                        setTimeout(() => {
                            submenu.style.height = 0 + "px";
                        }, 50);
                    });
                });
                submenu.style.height = submenu.offsetHeight + "px";
                animateHeight(submenu, 0, animationTime).then(() => {
                    setTimeout(() => {
                        submenu.style.height = 0 + "px";
                    }, 50);
                });
            }
        });
    });

    menuToggler.addEventListener("click", (e) => {
        const menuContentHeight = getTheoreticalHeight(menuContent.parentNode, menuContent, "100vh");
        const metaNavHeight = metaNav?.offsetHeight || 0;
        const menubarHeight = menuBar?.offsetHeight || 0;
        if (menuToggler.classList.contains("is-open")) {
            menuToggler.classList.remove("is-open");
            menuContent.classList.remove("is-open");
            menuContent.style.height = "0px";
            menuContent.style.top = menubarHeight + "px";
            menuContent.style.paddingTop = "0px";
            closeAllSubmenus(menuItems);
            toggleScrolling(true);
        } else {
            menuToggler.classList.add("is-open");
            menuContent.classList.add("is-open");
            toggleScrolling(false);
            menuContent.style.height = menuContentHeight - (metaNavHeight + menubarHeight) + "px";
            menuContent.style.top = menubarHeight + "px";
            menuContent.style.paddingTop = "1rem";
        }
    });
});

function closeAllSubmenus(submenus) {
    submenus.forEach((item) => item.classList.contains("open") && item.click());
}

function toggleScrolling(state) {
    if (state) {
        document.body.style.touchAction = "";
        document.body.style.overflowY = "";
        document.body.style.width = "";
    } else {
        const hasScrollbar = document.documentElement.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = hasScrollbar ? window.innerWidth - document.documentElement.clientWidth : 0;
        document.body.style.touchAction = "none";
        document.body.style.overflowY = "hidden";
        document.body.style.width = `calc(100% - ${scrollbarWidth}px)`;
    }
}

function animateHeight(element, newHeight, duration) {
    return new Promise((resolve) => {
        if (element.classList.contains("is-animating")) {
            resolve();
        }

        element.classList.add("is-animating");
        const startHeight = element.offsetHeight;
        const startTime = performance.now();

        function updateHeight(currentTime) {
            const elapsedTime = currentTime - startTime;
            const progress = Math.min(elapsedTime / duration, 1);
            const height = startHeight + (newHeight - startHeight) * progress;
            element.style.height = height + "px";

            if (progress < 1) {
                requestAnimationFrame(updateHeight);
            }
        }

        requestAnimationFrame(updateHeight);
        setTimeout(() => {
            element.classList.remove("is-animating");
            resolve();
        }, duration);
    });
}

function getTheoreticalHeight(parent, element, size = "auto") {
    const clone = element.cloneNode(true);
    clone.style.height = size;
    parent.appendChild(clone);
    const height = clone.offsetHeight;
    parent.removeChild(clone);
    return height;
}
